export enum SendStatusEnum {
  Unissued,
  Issued,
}

// 中奖的奖励类型:
export enum RewardTypeEnum {
  BONUS = 'BONUS', // 体验金
  CASHBACK = 'CASH_BACK', // 返现金
  LOTTERY = 'LOTTERT', // 转盘
}

export enum TaskTypeEnum {
  INVITED_AND_REGISTER = 'INVITED_AND_REGISTER', // 受邀注册
  INVITED_AND_KYC_SUPERPOSITION = 'INVITED_AND_KYC_SUPERPOSITION', // 邀请kyc叠加
  THANOS_TRADE = 'THANOS_TRADE', // 合约交易
  NEW_FIRST_RECHARGE = 'NEW_FIRST_RECHARGE', // 新人首充
  GENERAL_INVITE = 'GENERAL_INVITE', // 普通邀请
  SHARE_LINK = 'SHARE_LINK', // 分享链接
  TRANSFER_TO_THANOS = 'TRANSFER_TO_THANOS', // 划转至合约账号
  TRADE_AMOUNT_SUM = 'TRADE_AMOUNT_SUM', // 累计合约交易量
  PLAY_NEW_FUNCTION = 'PLAY_NEW_FUNCTION', // 体验新功能
  BOND = 'BOND', // 保证金
  TURNTABLE_LOTTERY = 'TURNTABLE_LOTTERY', // 转盘抽奖
}

export enum PrizeTypeEnum {
  BONUS = 'BONUS',
  CASHBACK = 'CASH_BACK',
  PRIZE = 'PRIZE',
  NFT = 'NFT',
}

export enum TaskStatusEnum {
  CANNOT_RECEIVE = 'CANNOT_RECEIVE',
  CAN_RECEIVE = 'CAN_RECEIVE',
  ALREADY_RECEIVE = 'ALREADY_RECEIVE',
}

export enum ActivityIdEnum {
  SUMMER = 34, // 夏日活动
  WELFARE = -1, // 福利中心
}

export enum ActivityIdEnumQa {
  SUMMER = 20, // 夏日活动
  WELFARE = -1, // 福利中心
}

// 生产环境
export enum ActivityChannelIdEnum {
  SUMMER = '1556930084129251330', // 夏日活动
  WELFARE = -1, // 福利中心
}

// 测试环境
export enum ActivityChannelIdEnumQa {
  SUMMER = '1555022024584019969', // 夏日活动
  WELFARE = -1, // 福利中心
}
